import Pattern from "../../assets/HeadingSectionPattern.svg";

const PageBanner = ({ title }: { title: string }) => {
  return (
    <div className="bg-[#c7461f] relative md:mt-20 mt-[60px] min-h-[300px] flex items-center">
      <img
        src={Pattern}
        className="absolute w-full h-full object-cover"
        alt=""
      />
      <div className="container z-50 relative flex items-center justify-center py-12 w-full">
        <h1 className="font-semibold text-center text-white lg:text-5xl md:text-4xl sm:text-3xl text-2xl">
          {title}
        </h1>
      </div>
    </div>
  );
};

export default PageBanner;
